import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { sbnbIcon } from '@app/ui';
import { environment } from '@env/environment';
import { Observable, map } from 'rxjs';
import { Brand, SocialType } from '../interfaces/brand.interface';
import { ApiResponse } from '../interfaces/lib/api.interface';

interface SocialTypeMetadata {
  icon: sbnbIcon;
  label: string;
}

@Injectable({ providedIn: 'root' })
export class BrandsService {
  environment = environment;

  private readonly http = inject(HttpClient);

  private readonly socialTypeMetadata: Record<SocialType, SocialTypeMetadata> = {
    [SocialType.TWITTER]: {
      icon: 'twitter',
      label: 'X / Twitter',
    },
    [SocialType.FACEBOOK]: {
      icon: 'facebook',
      label: 'Facebook',
    },
    [SocialType.INSTAGRAM]: {
      icon: 'instagram',
      label: 'Instagram',
    },
    [SocialType.YOUTUBE]: {
      icon: 'youtube',
      label: 'YouTube',
    },
    [SocialType.TIKTOK]: {
      icon: 'tiktok',
      label: 'TikTok',
    },
  };

  getSocialTypeMetadata(type: SocialType): SocialTypeMetadata {
    return this.socialTypeMetadata[type];
  }

  getBrand(): Observable<ApiResponse<Brand>> {
    return this.http.get<ApiResponse<Brand[]>>(`${this.environment.apiUrl}/settings/brands`).pipe(
      map((response) => ({
        data: response.data.length ? response.data[0] : this.placeholderBrand()
      }))
    );
  }

  updateBrand(brand: Brand): Observable<ApiResponse<Brand>> {
    if (!brand.uuid) {
      return this.http.post<ApiResponse<Brand>>(`${this.environment.apiUrl}/settings/brands`, brand);
    }

    return this.http.put<ApiResponse<Brand>>(`${this.environment.apiUrl}/settings/brands/${brand.uuid}`, brand);
  }

  placeholderBrand(): Brand {
    return {
      uuid: null,
      name: '',
      logo_url: '',
      icon_url: '',
      socials: [],
    };
  }
}
